/**
 * Centralized, validated access to environment variables.
 * Never read import.meta.env directly outside this file.
 */
export const env = {
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:1337/api",
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
};

if (!import.meta.env.VITE_API_URL && import.meta.env.DEV) {
  console.warn("[env] VITE_API_URL is not set — falling back to", env.API_URL);
}
